import * as React from "react";
import { createRoot } from "react-dom/client";
import { ApartmentSearchPage } from '@elo-ds/ui/dist/ApartmentSearchPage';


const renderApartmentSearch = () => {
    const container = document.getElementById('apartment-search-container');
    const language = document.getElementById("current-sitecore-context").getAttribute("data-language");
    const googleMapApiKey = document.getElementById("current-sitecore-context").getAttribute("data-google-map-key");
    const securityContainer = document && document.getElementsByClassName("security-container")[0];

    var requestVerificationToken = null;
    if (securityContainer) {
        requestVerificationToken = securityContainer.getElementsByTagName("input")[0].value;
    }

    if (container) {
        const cities = container.getAttribute("data-cities");
        const texts = container.getAttribute("data-label-texts");
        createRoot(container).render(
            <ApartmentSearchPage
                lang={language}            
                requestVerificationToken={requestVerificationToken}
                cities={JSON.parse(cities)}
                googleMapApiKey={googleMapApiKey}
                texts={JSON.parse(texts)}
            />
        );
    }
};
renderApartmentSearch();